<script>
	import { getContext } from "svelte";
 import { fade } from "svelte/transition";

	const { height, xScale } = getContext("LayerCake");

 const start = 1995
 const end = 2005;
 const textXOffset = 10;
 const textYOffset = 15;

</script>

<g class="axis-section-highlight" transition:fade>
 <rect
  x={$xScale(start)}
  y={0}
  width={$xScale(end) - $xScale(start)}
  height={$height}
  fill="rgba(255,255,255,0.1)"
 />
 <text
  class="axis-section-highlight__text"
  x={$xScale(start) + textXOffset}
  y={textYOffset}
  fill="#fff"
 >
  Assault Weapons Ban
 </text>
</g>

<style lang="scss">
 .axis-section-highlight__text {
  font-size: 16px;

  @media (max-width: $breakpoint-mobile) {
        font-size: 14px;
    }
 }
</style>
